import React, { useState, useContext, useEffect, useRef } from "react";
 import { useLocation } from "react-router-dom";
 import { useTranslation } from "react-i18next";
 import * as Config from "../../config/config";
 import { LoaderContext } from "../utils/Contexts";
 import API from "../../api/client";
 import * as ENDPOINTS from "../../api/endpoints";
 import SearchResult from "./result";
 import { useAuth } from "../../hooks/customers/AuthProvider";
 
 function GlobalSearch(props) {
   const { t } = useTranslation();
   const auth = useAuth();
   const customerId = auth.customer._id;
   const listInnerRef = useRef();
   const [searchTerm, setSearchTerm] = useState("");
   const { isLoader, setLoader } = useContext(LoaderContext);
   const [page, setPage] = useState(1);
   const [products, setProducts] = useState([]);
   const [isFetching, setIsFetching] = useState(false);
   const [isDataLoaded, setIsDataLoaded] = useState(false);
   const scrollableRef = useRef(null);
   const location = useLocation();
   const payload = {
     limit: Config.PRODUCTS_LIMIT,
   };
   const queryParams = new URLSearchParams(payload).toString();
   const getProducts = async (append) => {
     setLoader(true);
     let url = `${ENDPOINTS.GET_PRODUCTS}/${customerId}?${queryParams}&page=${page}`;
     if (searchTerm) {
       url = `${ENDPOINTS.PRODUCTS_SEARCH}/${customerId}?${queryParams}&page=${page}&name=${encodeURIComponent(searchTerm)}`;
     }
     const response = await API.getWithToken(url);
     setLoader(false);
     if (response.statusText === "OK") {
       if (append) {
         setProducts([...products, ...response.data.data.products]);
       } else {
         setProducts(response.data.data.products);
       }
       
       if (response.data.data.products.length) {
         setPage((prevPage) => prevPage + 1);
         setIsFetching(false);
       }
     }
 
     setIsDataLoaded(true);
   };
 
   useEffect(() => {
     const listInnerElement = listInnerRef.current;
 
     if (listInnerElement) {
       listInnerElement.addEventListener("scroll", handleScroll);
 
       return () => {
         listInnerElement.removeEventListener("scroll", handleScroll);
       };
     }
   }, []);
 
   const handleScroll = (e) => {
     if (listInnerRef.current) {
       const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
       const isNearBottom = scrollTop + clientHeight + 5 >= scrollHeight;
       if (isNearBottom && !isFetching) {
         setIsFetching(true);
       }
     }
   };
 
   const handleInputChange = (e) => {
     const keayword = e.target.value;
     setPage(1);
     setSearchTerm(keayword);
   };
 
   useEffect(() => {
     if (!searchTerm) return;
     const delayInputTimeoutId = setTimeout(() => {
       getProducts(false);
     }, 500);
     return () => clearTimeout(delayInputTimeoutId);
   }, [searchTerm, 500]);
 
   useEffect(() => {
     if (!isFetching || !searchTerm) return;
     getProducts(true);
   }, [searchTerm, isFetching, page]);
 
   const renderChildren = () => {
     return React.Children.map(props.children, (child) => {
       return React.cloneElement(child, {
         page: page,
         setPage: setPage,
         isFetching: isFetching,
         setIsFetching: setIsFetching,
       });
     });
   };
 
   useEffect(() => {
    setPage(1);
    // setPage(0);
     setSearchTerm('');
   }, [location.pathname]);
   
   return (
     <div className="favbg">
       <div className="innerwrapper Favourites_search">
         <div
           className="search_fav global-search customscroll"
           ref={listInnerRef}
         >
           <input
             type="search"
             placeholder={t("searchtxt")}
             value={searchTerm}
             onChange={handleInputChange}
           />
           {searchTerm != "" && products.length > 0 && <SearchResult products={products}/>}
           {isDataLoaded && searchTerm != "" &&
             products.length <= 0 &&
             (
               <div className="empty-search-result-wrapper">
                 <div className="empty-search-result">No result found</div>
               </div>
             )}
           {!searchTerm && renderChildren()}
         </div>
       </div>
     </div>
   );
 }
 
 export default GlobalSearch;